import { useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import { getFetchState } from 'features/common/fetch/selectors';
import { fetchUnlockedClients, loadMore, loadPage } from 'features/views/unlockedClients/actions';
import { getUnlockedClientsRecords } from 'features/views/unlockedClients/selectors';

import UnlockedClientsTableRow from './UnlockedClientsTableRow';

const UnlockedClientsOverviewTable = () => {
	const dispatch = useDispatch();

	const handleReload = useCallback(() => {
		dispatch(fetchUnlockedClients());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(loadPage(page - 1));
		},
		[dispatch],
	);

	const handleLoadMore = useCallback(() => {
		dispatch(loadMore());
	}, [dispatch]);

	const records = useSelector(getUnlockedClientsRecords);
	const fetchState = useSelector(getFetchState(fetch.constants.urls.unlockedClientsList));

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.unlockedClientsList} onReload={handleReload}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>{getLabelMessage('unlockedClients:client')}</TableCell>
						<TableCell>
							<div>{getLabelMessage('unlockedClients:personIn')}</div>
							<div>{getLabelMessage('unlockedClients:businessIn')}</div>
						</TableCell>
						<TableCell>{getLabelMessage('unlockedClients:birthDate')}</TableCell>
						<TableCell>{getLabelMessage('unlockedClients:unlockChannels')}</TableCell>
						<TableCell>
							<div>{getLabelMessage('unlockedClients:unlockedFromTableHeader')}</div>
							<div>{getLabelMessage('unlockedClients:unlockedToTableHeader')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('unlockedClients:extendedFrom')}</div>
							<div>{getLabelMessage('unlockedClients:extendedTo')}</div>
						</TableCell>
						<TableCell />
					</TableRow>
				</TableHead>
				<TableBody>
					{isNilOrEmpty(records) ? (
						<TableHasNoResults fetchState={fetchState} />
					) : (
						records.map((record) => (
							<TableRow>
								<UnlockedClientsTableRow record={record} />
							</TableRow>
						))
					)}
				</TableBody>
				<PaginationRow
					fetchStorePath={fetch.constants.urls.unlockedClientsList}
					onLoadNext={handleLoadMore}
					onPaginationClick={handlePaginationClick}
				/>
			</Table>
		</ComponentLoader>
	);
};

export default UnlockedClientsOverviewTable;
